import FingerprintJS from '@fingerprintjs/fingerprintjs'

let fpPromise: Promise<any> | undefined

if (typeof window !== 'undefined') {
  fpPromise = FingerprintJS.load()
}

export async function getFingerprint(): Promise<string> {
  if (!fpPromise) {
    return 'unknown-fingerprint'
  }
  
  try {
    const fp = await fpPromise
    const result = await fp.get()
    return result.visitorId
  } catch (error) {
    console.error('Failed to get fingerprint:', error)
    return 'error-fingerprint'
  }
}

